module.exports = __webpack_public_path__ + "media/tape-nav/community-discover-icon-329c74bd.svg";